import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import ElementUI from 'element-ui';
import './reset.css';
import { prefixImgUrl, prefixImg } from './directives'
Vue.use(ElementUI);
import { Loading } from 'element-ui';
Vue.use(Loading.directive);

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.directive('prefixImgUrl', prefixImgUrl)
Vue.prototype.$prefixImg = prefixImg;
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
